@let t = tabla();
<div class="super-ejecutivo-tabla">
  @if (descargable()) {
    <div class="super-ejecutivo-tabla-acciones" [class]="claseFueraDeImagen">
      <app-super-ejecutivo-descarga [etiqueta]="etiquetaDescarga" [descargando]="descargando()"
        (imagen)="descargarImagen()" (excel)="descargarExcel()"></app-super-ejecutivo-descarga>
    </div>
  }
  <div class="super-ejecutivo-tabla-desplazable">
    <table #tablaHtml>
      <thead>
        <tr>
          @for (columna of t.columnasHtml; track $index; let i = $index) {
            <th [style.text-align]="t.alineacion[i]" [innerHTML]="columna"></th>
          }
        </tr>
      </thead>
      <tbody>
        @for (fila of t.filasHtml; track $index) {
          <tr>
            @for (celda of fila; track $index; let i = $index) {
              <td [style.text-align]="t.alineacion[i]" [innerHTML]="celda"></td>
            }
          </tr>
        }
      </tbody>
    </table>
  </div>
</div>
